import { EmployeeProperties } from "./employee.type";
import { GroupProperties } from "./group.type";
import { ProfileProperties } from "./profile.type";
import { TeamsMemberFeeItemProperties, TeamsMemberFeeProperties } from "./teamsMemberFee.type";
import { UserProperties } from "./user.type";

export enum EGroupMemberStatus {
	ACTIVE = "ACTIVE",
	TRANSFERED = "TRANSFERED",
}

export interface GroupMemberProperties {
	groupMemberId: string;
	groupId: string;
	userId: string;
	employeeId: string;
	teamsMemberFees: TeamsMemberFeeProperties[];
	isLeader: boolean;
	createdByUserId?: string;
	createdByUserMeta?: any;
	createdAt: Date;
	updatedAt: Date;

	group?: Omit<GroupProperties, "group">;
	user?: UserProperties;
	profile?: ProfileProperties;
	employee?: EmployeeProperties;
}

export interface ListGroupMemberQuery {
	filterGroupId?: string;
	filterUserId?: string;
	filterEmployeeId?: string;
	filterStatus?: string;

	includeData?: string;
	sort?: string;
}
